import { castleSideOf, updateCastling } from './castling.js';
import { pawnDirection } from './moveGen.js';
import {
  EMPTY, FLAG_DOUBLE_PUSH, FLAG_EN_PASSANT, NO_SQUARE, PAWN, opposite, pieceCode, typeOf,
  type Move, type Position,
} from './types.js';
import { fileOf, rowOf, squareAt } from './squares.js';

/**
 * The position after `move`. Does not check legality — callers pass moves from
 * the generators. Returns a new position; the input is never mutated.
 */
export function applyMove(pos: Position, move: Move): Position {
  const board = new Int8Array(pos.board);
  board[move.from] = EMPTY;
  board[move.to] = move.promotion === EMPTY ? move.piece : pieceCode(move.promotion, pos.turn);

  if ((move.flags & FLAG_EN_PASSANT) !== 0) {
    board[squareAt(fileOf(move.to), rowOf(move.from))] = EMPTY;
  }

  const castle = castleSideOf(move);
  if (castle !== undefined) {
    board[castle.rookTo] = board[castle.rookFrom] ?? EMPTY;
    board[castle.rookFrom] = EMPTY;
  }

  const epSquare = (move.flags & FLAG_DOUBLE_PUSH) !== 0
    ? squareAt(fileOf(move.from), rowOf(move.from) + pawnDirection(pos.turn))
    : NO_SQUARE;

  const resetsClock = typeOf(move.piece) === PAWN || move.captured !== EMPTY;
  return {
    board,
    turn: opposite(pos.turn),
    castling: updateCastling(pos.castling, move.from, move.to),
    epSquare,
    halfmoveClock: resetsClock ? 0 : pos.halfmoveClock + 1,
    fullmoveNumber: pos.turn === 'b' ? pos.fullmoveNumber + 1 : pos.fullmoveNumber,
  };
}
